// 下拉面板。Dropdown 走 Popper plain，盒子写在这里；业务覆盖 `.sqt-dropdown-menu` 即可
.#{$namespace}-dropdown-menu {
	margin: 0;
	padding: 4px 0;
	list-style: none;
	overflow: auto;
	border-radius: 8px;
	background-color: $white-color;
	box-shadow: 0 0 1px 1px #{alpha-color($black-color, 12%)};
}
